/*
 * Copyright (c) 2026. Bluemate B.V.
 */

import {migrateLegacyBrandKeys} from './legacyKeyMigration';

migrateLegacyBrandKeys();
